import { useParams } from 'react-router';
import EditScheduleView from './shared/EditScheduleView';
import { Api } from '../../api';
import { ScreenError, SoloLoading } from '../../components';
import { useApiRead } from 'api-read-hook';

export default function EditScheduleScreen() {
  const { id } = useParams();

  const clinicianApi = useApiRead<Api.User.V_ClinicianDetailAsAdmin>(
    id ? `/clinicians/${id}` : null,
  );

  if (!id) return null;

  if (clinicianApi.error) return <ScreenError {...clinicianApi} />;
  if (!clinicianApi.data) return <SoloLoading />;

  const clinicianProfile = clinicianApi.data.clinicianProfile;
  if (!clinicianProfile)
    return <ScreenError error={new Error('Clinician has no profile.')} />;

  return (
    <EditScheduleView
      clinicianId={id}
      durationMinutes={clinicianProfile.appointmentDuration}
      bufferMinutes={clinicianProfile.appointmentBuffer}
    />
  );
}
